var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7CB6E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.671 22.254a3.004 3.004 0 0 1-3.342 0l-8.196-5.464a2.953 2.953 0 0 1-.133-.095v8.953a1.84 1.84 0 0 0 1.841 1.841H28.16A1.84 1.84 0 0 0 30 25.65v-8.954a2.888 2.888 0 0 1-.134.095l-8.195 5.464z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.783 15.814 8.196 5.464a1.84 1.84 0 0 0 2.042 0l8.196-5.464c.49-.327.783-.873.783-1.464 0-1.015-.826-1.84-1.84-1.84H11.84c-1.014 0-1.84.825-1.84 1.841 0 .59.293 1.136.783 1.463z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6355d5a95894cd3ee0f2b1bc703941fd.svg";
export { ForwardRef as ReactComponent };